(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-product-in-use"] && !Shopify.designMode) return;
  try {
    
  const initializeProductInUse = (section) => {
    if (section.dataset.hcProductInUseInitialized === 'true') return;

    const track = section.querySelector('[data-hc-product-in-use-track]');
    const current = section.querySelector('[data-hc-product-in-use-current]');
    const cards = Array.from(section.querySelectorAll('[data-hc-product-in-use-card]'));

    section.dataset.hcProductInUseInitialized = 'true';

    section.querySelectorAll('[data-hc-product-in-use-play]').forEach((button) => {
      const mediaContainer = button.closest('.hc-product-in-use__media');
      const video = mediaContainer ? mediaContainer.querySelector('video') : null;

      if (!video) return;

      const showPlayButton = () => {
        button.hidden = false;
      };

      const hidePlayButton = () => {
        button.hidden = true;
      };

      button.addEventListener('click', () => {
        const playRequest = video.play();

        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(showPlayButton);
        }
      });

      video.addEventListener('play', hidePlayButton);
      video.addEventListener('playing', hidePlayButton);
      video.addEventListener('pause', showPlayButton);
      video.addEventListener('ended', showPlayButton);
    });

    if (!track || !current || cards.length < 2) return;

    let frame;

    const updateCounter = () => {
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - trackCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      current.textContent = String(closestIndex + 1);
    };

    const requestUpdate = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateCounter);
    };

    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    updateCounter();
  };

  document.querySelectorAll('[data-hc-product-in-use]').forEach(initializeProductInUse);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-hc-product-in-use]');
    if (section) initializeProductInUse(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helena-bw-venteside"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.helenaBwCaptchaBound) return;
  window.helenaBwCaptchaBound = true;
  let apiPromise;
  function loadApi(key) {
    if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') return Promise.resolve();
    if (!apiPromise) {
      apiPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://www.recaptcha.net/recaptcha/api.js?render=' + encodeURIComponent(key);
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      }).catch(error => { apiPromise = undefined; throw error; });
    }
    return apiPromise;
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-hbwv-recaptcha]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.hbwvBusy === 'true') return;
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('.hbwv__error');
    const field = form.querySelector('[data-hbwv-token]');
    const key = form.dataset.hbwvRecaptcha;
    const label = button.value;
    let timer;
    form.dataset.hbwvBusy = 'true';
    error.hidden = true;
    field.value = '';
    button.disabled = true;
    button.value = 'Kontrollerer …';
    try {
      const token = await Promise.race([
        loadApi(key).then(() => new Promise((resolve, reject) => {
          window.grecaptcha.ready(() => {
            try {
              window.grecaptcha.execute(key, { action: 'form_submission' }).then(resolve, reject);
            } catch (failure) { reject(failure); }
          });
        })),
        new Promise((resolve, reject) => { timer = setTimeout(() => reject(new Error('timeout')), 15000); })
      ]);
      if (!token) throw new Error('missing token');
      field.value = token;
      HTMLFormElement.prototype.submit.call(form);
    } catch (failure) {
      error.textContent = 'Sikkerhetskontrollen kunne ikke fullføres. Prøv igjen. Hvis problemet fortsetter, last siden på nytt.';
      error.hidden = false;
      button.disabled = false;
      button.value = label;
      form.dataset.hbwvBusy = 'false';
    } finally { clearTimeout(timer); }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helena-reviews-intro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'qNlyfDqZ4IFtbTna9Q5y47EpPwm2wwK6R9vkCNJW';
  const source = 'https://staticw2.yotpo.com/' + key + '/widget.js';
  function refresh() {
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      window.yotpo.initWidgets();
    }
  }
  function mount() {
    if (!document.querySelector('.hr-intro__badge #y-badges')) return;
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      refresh();
      return;
    }
    const existing = Array.from(document.scripts).find(script => {
      if (!script.src) return false;
      const url = new URL(script.src, document.baseURI);
      return url.hostname === 'staticw2.yotpo.com' && url.pathname === '/' + key + '/widget.js';
    });
    if (existing) {
      if (!existing.dataset.helenaBadgeListener) {
        existing.dataset.helenaBadgeListener = 'true';
        existing.addEventListener('load', refresh, { once: true });
      }
      return;
    }
    window.yotpo_app_key = key;
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.addEventListener('load', refresh, { once: true });
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helena-secret-box-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-hsp-variant]')) return;
  const destination = new URL(window.location.href);
  destination.searchParams.set('variant', event.target.value);
  window.location.assign(destination.toString());
});

  } catch(e) { console.error(e); }
})();
})();
